<template>
  <a-card>
    <a-tabs :default-active-key="defaultActiveKey" @change="onChange">
      <a-tab-pane v-if="nextMoveStatus" key="next" tab="通过">
        <a-alert class="workflow-alert-info" type="info" show-icon>
          <template slot="message">
            <span>{{ `审批通过将流转至「${options[nextForm.to_step]}」; ` }}</span>
            <template v-if="configConfirmProgress !== null">
              <span v-for="(t, index) in configConfirmProgress" :key="index">{{ t.name }}: <user-profiles :value="t.users" avatar /></span>
            </template>
            <span v-else>{{ reviewUser }}</span>
          </template>
        </a-alert>
        <a-form-model v-if="operationPermission && associableStatus !== 2" ref="nextForm" :model="nextForm" :rules="rules" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }" class="small-form-model">
          <a-form-model-item v-if="nextOptions.length > 1" label="流转步骤" prop="to_step">
            <a-radio-group v-model="nextForm.to_step">
              <a-radio v-for="step in nextOptions" :key="step.id" :value="step.id"> {{ step.name }} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="canAddMrd && [130].includes(currentStepId)" label="是否需要MRD" prop="need_mrd">
            <a-radio-group v-model="nextForm.need_mrd" style="margin-left: 5px">
              <a-radio :value="1"> 是 </a-radio>
              <a-radio :value="0"> 否 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="isBusinessRequirement && [138].includes(currentStepId)" label="协同验收人" prop="collaborator">
            <a-select v-model="nextForm.collaborator" mode="multiple" style="width: 400px" allow-clear placeholder="请选择协同验收人" show-search :filter-option="utils.filterOption">
              <a-select-option v-for="(user, index) in $store.state.allUsers" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="confirmItems.length > 0" label="确认项" prop="confirm_items">
            <a-checkbox style="margin-left: 17px" :checked="checkedAll" @change="onConfirmAllItemChange($event)">{{ '全选' }}</a-checkbox>
            <br />
            <a-checkbox-group v-model="checkedConfirms">
              <a-list size="small" bordered :data-source="confirmItems" style="width: 960px">
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-checkbox :value="item.index" @change="onConfirmItemChange($event, item.index)">
                    <span>{{ item.content }}</span>
                    <a-tooltip v-if="item.description" style="padding-left: 2px">
                      <pre slot="title" style="margin-bottom: 0">{{ item.description }}</pre>
                      <a-icon type="question-circle" style="cursor: pointer; color: red; font-size: 15px" />
                    </a-tooltip>
                  </a-checkbox>
                </a-list-item>
              </a-list>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item v-if="currentStep.next !== null && !isBusinessRequirement" label="发布评审" prop="release_ids">
            <a-radio-group v-if="currentStep.release_list.length > 0" v-model="nextForm.release_ids" style="width: 960px" :default-value="currentStep.release_list[0].release_id">
              <a-list size="small" bordered :data-source="currentStep.release_list">
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-radio class="release-radio" :value="item.release_id">
                    <a @click="onDetail(item)"> {{ item.release_title }} </a>
                  </a-radio>
                </a-list-item>
              </a-list>
            </a-radio-group>
            <div v-if="currentStep.back === null">
              <a-button v-tc="{ name: '创建发布评审' }" type="primary" icon="plus" @click="onCreate"> 创建发布评审 </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="mustBindTestPlans" class="testplan-form-item" label="测试计划">
            <a-table v-if="testPlans.length > 0" :pagination="false" size="small" :columns="testPlanColumns" row-key="id" :data-source="testPlans" class="plan_table">
              <span slot="key" slot-scope="text, record"> {{ record.key }}</span>
              <span slot="name" slot-scope="text, record">
                <a-tooltip placement="top" :title="record.name">
                  <a class="issue_title" :href="planLink(record)" target="_blank">{{ record.name }}</a>
                </a-tooltip>
              </span>
              <span slot="status" slot-scope="text, record">
                <a-badge :status="testPlanStatus[record.status].status" :text="testPlanStatus[record.status].label" />
              </span>
              <span slot="progress" slot-scope="text, record">
                <a-progress :percent="record.progress" size="small" style="width: 130px" />
              </span>
              <span slot="action" slot-scope="text, record">
                <a v-tc="{ name: '移除测试计划' }" @click="deletePlan(record)">移除</a>
              </span>
            </a-table>
            <div>
              <a-button v-tc="{ name: '关联测试计划' }" type="success" icon="plus" @click="onAddTestPlan"> 关联测试计划 </a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="needCompatibilityOrPerformance" class="testplan-form-item" label="兼容性测试">
            <div>
              <a-radio-group v-model="nextForm.compTest.result">
                <a-radio :value="1"> 通过 </a-radio>
                <a-radio :value="2"> 失败 </a-radio>
              </a-radio-group>
              <vditor-editor v-model="nextForm.compTest.description" :height="200" :width="960" />
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="needCompatibilityOrPerformance" class="testplan-form-item" label="性能测试">
            <div>
              <a-radio-group v-model="nextForm.perfTest.result">
                <a-radio :value="1"> 通过 </a-radio>
                <a-radio :value="2"> 失败 </a-radio>
              </a-radio-group>
              <vditor-editor v-model="nextForm.perfTest.description" :height="200" :width="960" />
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="mustBindTestPlans" class="testplan-form-item" label="精准测试">
            <span>
              <a-button v-tc="{ name: '获取推荐用例集' }" type="dashed" icon="eye" @click="getAccGenerateCases()">获取推荐用例集</a-button>
            </span>
          </a-form-model-item>
          <a-form-model-item v-if="needAutomationTest" label="回归测试">
            <workflow-test-suit :source-data="currentStep.automation.review" :step-id="currentStepId" tag="review" />
          </a-form-model-item>
          <a-form-model-item v-if="needAutomationTest" label="质量验证">
            <workflow-test-suit :source-data="currentStep.automation.qa_verify" :step-id="currentStepId" tag="qa_verify" />
          </a-form-model-item>
          <a-form-model-item v-if="needRetrospect" label="是否需追溯" prop="isValueRetrospect">
            <a-switch v-model="nextForm.isValueRetrospect" @change="onChangeIsValueRetrospect" />
          </a-form-model-item>
          <a-form-model-item v-if="needRetrospect && nextForm.isValueRetrospect" label="追溯类型" prop="retrospectType">
            <a-checkbox-group v-model="nextForm.retrospectType">
              <a-checkbox :value="1" disabled> 应用追溯</a-checkbox>
              <a-checkbox :value="2"> 价值追溯</a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item label="备注信息" prop="comment">
            <vditor-editor v-model="nextForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-space>
              <a-button v-if="!noNeedQaTest" v-tc="{ name: '通过流程' }" :disabled="!isLastQaTimeAfter || !haveMrd ? true : nextSubmitRequire" class="submit-button" type="primary" :loading="loading.next" @click="onSubmit('next')"> 提交 </a-button>
              <a-button v-if="noNeedQaTest" v-tc="{ name: '通过流程' }" :disabled="nextSubmitRequire" class="submit-button" type="primary" :loading="loading.next" @click="onSubmit('normalNext')"> 通过 </a-button>
              <a-button v-if="needAutomationTest" v-tc="{ name: '自动化通过流程' }" :disabled="nextSubmitRequire" class="submit-button" type="primary" :loading="loading.next" @click="onSubmit('autoNext')"> 自动化通过 </a-button>
              <a-button v-if="noNeedQaTest" v-tc="{ name: '免验通过流程' }" :disabled="nextSubmitRequire" class="submit-button" type="primary" :loading="loading.next" @click="onSubmit('noNeedQa')"> 免验 </a-button>
              <a-button v-if="isBusinessRequirement && currentStepId === 134 && (isPo || isTechnicalManager)" v-tc="{ name: '认领需求' }" class="submit-button" type="primary" :loading="loading.next" @click="brClaim('me')"> 认领需求 </a-button>
              <a-button v-if="false && isBusinessRequirement && currentStepId === 134 && isPmom" v-tc="{ name: '指派需求' }" class="submit-button" type="primary" :loading="loading.next" @click="brClaim('other')"> 指派需求 </a-button>
              <span v-if="!isLastQaTimeAfter" style="color: red">
                <!-- 需求问答48小时才允许提交,剩余时间{{ getCountdown(brInfo.lastQaTime) }}; -->
                还剩{{ getCountdown(brInfo.lastQaTime) }}才可以提交,解锁时间[{{ brInfo.lastQaTime }}];
              </span>
              <span v-if="!haveMrd" style="color: red">请先关联MRD后进行提交</span>
            </a-space>
          </a-form-model-item>
          <a-alert v-if="processingServices.length > 0" :type="templateId !== 17 ? 'warning' : 'info'" show-icon banner>
            <span slot="message">{{ `「${processingServices.map(item => item.service_name).join(',')}」服务有早于当前镜像版本的流程未完成` }}</span>
          </a-alert>
        </a-form-model>
        <a-button v-if="isBusinessRequirement && currentStepId === 134 && (isPo || isTechnicalManager) && !(operationPermission && associableStatus !== 2)" class="submit-button" type="primary" :loading="loading.next" @click="brClaim('me')"> 认领需求 </a-button>
      </a-tab-pane>
      <a-tab-pane v-if="backMoveStatus" key="back" tab="不通过">
        <a-alert class="workflow-alert-info" type="info" show-icon>
          <template slot="message">
            <span>{{ `审批不通过将流转至「${options[backForm.to_step]}」; ` }}</span>
            <template v-if="configConfirmProgress !== null">
              <span v-for="(t, index) in configConfirmProgress" :key="index">{{ t.name }}: <user-profiles :value="t.users" avatar /></span>
            </template>
            <span v-else>{{ reviewUser }}</span>
          </template>
        </a-alert>
        <a-form-model v-if="operationPermission && associableStatus !== 2" ref="backForm" :model="backForm" :rules="rules" class="small-form-model" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }">
          <a-form-model-item v-if="backOptions.length > 1" label="流转步骤" prop="to_step">
            <a-radio-group v-model="backForm.to_step">
              <a-radio v-for="step in backOptions" :key="step.id" :value="step.id"> {{ step.name }} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="currentStep.back !== null && currentStep.release_list.length > 0 && !isBusinessRequirement" label="发布评审" prop="release_ids">
            <a-radio-group v-if="currentStep.release_list.length > 0" v-model="backForm.release_ids" style="width: 960px" :default-value="currentStep.release_list[0].release_id">
              <a-list size="small" bordered :data-source="currentStep.release_list">
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-radio class="release-radio" :value="item.release_id">
                    <a v-tc="{ name: '跳转发布评审' }" @click="onDetail(item)"> {{ item.release_title }} </a>
                  </a-radio>
                </a-list-item>
              </a-list>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="currentStep.back !== null && !isBusinessRequirement" label="验证结果" prop="result">
            <a-radio-group v-model="backForm.result" name="radioGroup">
              <a-radio v-for="item in currentStep.back" :key="item" :value="item" @change="getTagList(releaseActions[item].code)"> {{ releaseActions[item].label }} </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="tagData.length > 0" label="原因分类" prop="tags">
            <a-checkbox-group v-model="backForm.tags">
              <a-checkbox v-for="tag in tagData" :key="tag.id" :value="tag.id"> {{ tag.name }} </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item v-if="!isBusinessRequirement" label="关联已有缺陷" prop="bug_list">
            <div style="width: 960px">
              <issue-relation-modal v-model="backForm.bug_list" :bug-list="bugList" />
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="!isBusinessRequirement" label="创建缺陷并关联" prop="bug_list">
            <div style="width: 960px">
              <a-button v-tc="{ name: '创建缺陷' }" icon="plus" type="dashed" class="search-button" @click="onAddIssue"> 创建缺陷 </a-button>
              <issue-edit-modal ref="editModalRef" source-type="workflow" @callback="callback" />
            </div>
          </a-form-model-item>
          <!-- <a-form-model-item v-if="!isBusinessRequirement" label="创建体验问题并关联" prop="bug_list">
            <div style="width: 960px">
              <a-button v-tc="{ name: '创建缺陷' }" icon="plus" type="dashed" class="search-button" @click="onAddIssue"> 创建缺陷 </a-button>
              <issue-edit-modal ref="editModalRef" source-type="workflow" @callback="callback" />
            </div>
          </a-form-model-item> -->
          <a-form-model-item v-if="templateId === 4" label="自测计划" prop="bug_list" class="testplan-form-item">
            <div style="width: 960px">
              <test-plan-relation-modal :plan-list="devTestPlans" @change="rejectTestPlanChange" />
            </div>
          </a-form-model-item>
          <a-form-model-item label="备注信息" prop="comment">
            <vditor-editor v-model="backForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button v-tc="{ name: '不通过流程' }" class="submit-button" type="primary" :loading="loading.back" @click="onSubmit('back')"> 提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane key="comment" tab="评论">
        <a-form-model ref="commentForm" :model="commentForm" :rules="rules" class="small-form-model" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }">
          <a-form-model-item label="评论内容" prop="comment">
            <vditor-editor v-model="commentForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button v-tc="{ name: '评论流程' }" class="submit-button" type="primary" :loading="loading.comment" @click="onSubmit('comment')"> 提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane v-if="currentStep && currentStep.reviews && currentStep.reviews.length > 0" key="review" tab="审批任务">
        <workflow-review-record :data-source="currentStep.reviews" />
      </a-tab-pane>
    </a-tabs>
    <rollback-modal ref="rollbackModalRef" @back="handleBack" @cancle="loading.back = false" />
    <workflow-test-plan-modal :project-id="projectId" :workflow-id="workflowId" :step-id="currentStepId" :default-plans="nextForm.test_plans" :is-show="testPlanVisible" @test-plan-change="testPlanChange" @close="closeTestPlanModal" />
    <br-claim-modal ref="brClaimModalRef" @saveOk="brClaimOk" />
  </a-card>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { applicationVersionList } from '@/api/tools/application';
import { updateBusinessRequirementSimpleField } from '@/api/business/requirement';
import { releaseActions, testPlanStatus, taskDeliveryConfirmItems, integratedConfirmItems, nvwaEnvs, requirementDesignStatus } from '@/utils/dictionary';
import { workflowMove, workflowForceAddPO, workflowComment, unBindWorkflowTestPlan, workflowTestPlans, automationTrigger, getWorkflowConfirmItems, updateWorkflowConfirmItemStatus, getAccCases, businessReqModify, queryConfigConfirmProgress } from '@/api/project/workflow';

import moment from 'moment';
import Accurate from '@/api/project/accurate';
import VditorEditor from '@/components/VditorEditor';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import RollbackModal from '@/pages/project/workflow/components/RollbackModal';
import BrClaimModal from '@/pages/business/requirement/components/BrClaimModal';
import WorkflowTestSuit from '@/pages/project/workflow/components/WorkflowTestSuit';
import WorkflowReviewRecord from '@/pages/project/workflow/components/WorkflowReviewRecord';
import WorkflowTestPlanModal from '@/pages/project/workflow/components/WorkflowTestPlanModal';
import IssueRelationModal from '@/pages/project/workflow/release/components/IssueRelationModal';
import TestPlanRelationModal from '@/pages/project/workflow/release/components/TestPlanRelationModal';

const testPlanColumns = [
  {
    dataIndex: 'key',
    key: 'key',
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'key' }
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 150,
    scopedSlots: { customRender: 'progress' }
  },
  {
    key: 'action',
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    BrClaimModal,
    VditorEditor,
    RollbackModal,
    IssueEditModal,
    WorkflowTestSuit,
    IssueRelationModal,
    WorkflowReviewRecord,
    TestPlanRelationModal,
    WorkflowTestPlanModal
  },
  props: {
    projectId: {
      type: [Number, String],
      default: null
    },
    workflowId: {
      type: [Number, String],
      default: null
    },
    currentStep: {
      type: Object,
      default: () => {
        return {};
      }
    },
    workflowStatus: {
      type: [Number, String],
      default: null
    },
    associableStatus: {
      type: Number,
      default: 0
    },
    processingServices: {
      type: [Array, String],
      default: () => {
        return [];
      }
    },
    templateId: {
      type: [Number, String],
      default: null
    },
    canAddMrd: {
      type: Boolean,
      default: false
    },
    brInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      nvwaEnvs,
      releaseActions,
      testPlanStatus,
      testPlanColumns,
      integratedConfirmItems,
      requirementDesignStatus,
      taskDeliveryConfirmItems,
      onlineDiff: {
        fileTree: []
      },
      testDiff: {
        fileTree: []
      },
      isAutoPass: null,
      isBusinessRequirement: false,
      packageList: [],
      checkedConfirms: [],
      height: 220,
      loading: {
        next: false,
        back: false,
        comment: false
      },
      tinymceId: new Date().getTime() + '',
      options: {},
      issueId: null,
      copyIssueId: null,
      issueDeadlineConfig: {},
      nextOptions: [],
      backOptions: [],
      operationUsers: [],
      operationPermission: false,
      onlineAccVisible: false,
      testAccVisible: false,
      defaultActiveKey: 'next',
      // projectId: parseInt(this.$route.params.project_id) || null,
      // workflowId: parseInt(this.$route.query.workflowId) || null,
      checkRelease: null,
      nextForm: {
        team_id: null,
        release_ids: null,
        operation_type: 'next',
        to_step: null,
        comment: '',
        test_plans: [],
        compTest: {
          result: 0,
          description: ''
        },
        perfTest: {
          result: 0,
          description: ''
        },
        apiTest: {
          result: 0,
          taskId: null,
          env: nvwaEnvs[0].value
        },
        uiTest: {
          result: 0,
          taskId: null,
          taskUrl: null,
          package: null
        },
        confirm_items: null
      },
      backForm: {
        release_ids: null,
        operation_type: 'back',
        result: null,
        tags: [],
        to_step: null,
        comment: '',
        bug_list: [],
        plan_list: []
      },
      commentForm: {
        operation_type: 'comment',
        to_step: null,
        comment: ''
      },
      rules: {
        to_step: [{ required: true, message: '流转步骤不能为空', trigger: 'blur' }],
        comment: [{ required: true, message: '备注信息不能为空', trigger: 'blur' }],
        release_ids: [{ required: true, message: '请选择发布评审', trigger: 'blur' }],
        result: [{ required: true, message: '请选择验证结果', trigger: 'blur' }],
        tags: [{ required: true, message: '请选择原因分类', trigger: 'blur' }],
        test_plans: [{ required: this.mustBindTestPlans, message: '请关联测试计划', trigger: 'blur' }],
        confirm_items: [{ required: true, message: '请勾选确认项', trigger: 'blur' }],
        need_mrd: [{ required: true, message: '请确认是否需要MRD', trigger: 'blur' }]
      },
      tagData: [],
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      bugList: {},
      testPlanVisible: false,
      testPlans: [],
      devTestPlans: [],
      currentStepId: null,
      accCaseOccur: false,
      needCompatibilityOrPerformance: false,
      needAutomationTest: false,
      noNeedQa: null,
      confirmItemStatus: {},
      configConfirmProgress: null
    };
  },
  computed: {
    /**
     * 是否全选
     */
    checkedAll() {
      return this.checkedConfirms.length === this.confirmItems.length ? true : null;
    },
    /**
     * 确认项
     */
    confirmItems() {
      switch (this.currentStepId) {
        case 94:
          return this.taskDeliveryConfirmItems;
        case 145:
          return this.integratedConfirmItems;
        default:
          return [];
      }
    },
    isPmom() {
      const userId = this.$store.state.userInfo.id;
      const orgList = this.$store.getters.globalConfig('pmom', []);
      const use = orgList.find(item => item.user_id === userId);
      return !!use;
    },
    isPo() {
      const userId = this.$store.state.userInfo.id;
      const orgList = this.$store.getters.globalConfig('br_po', []);
      const use = orgList.find(item => item.user_id === userId);
      return !!use;
    },
    isTechnicalManager() {
      const userId = this.$store.state.userInfo.id;
      const orgList = this.$store.getters.globalConfig('br_technical_manager', []);
      const use = orgList.find(item => item.user_id === userId);
      return !!use;
    },
    isLastQaTimeAfter() {
      if (this.brInfo && this.brInfo.requirementType === 3) {
        return true;
      }
      // 需求问答48小时后
      if (this.isBusinessRequirement && this.currentStepId === 134 && this.brInfo.lastQaTime) {
        try {
          return moment(this.brInfo.lastQaTime).isBefore(moment());
        } catch (e) {
          console.log(e);
        }
      }
      return true;
    },
    haveMrd() {
      // 判断是否有MRD
      if (this.isBusinessRequirement && [131, 151].includes(this.currentStepId)) {
        if (!this.brInfo.documents || this.brInfo.documents.length === 0) {
          return false;
        }
      }
      return true;
    },
    needRetrospect() {
      // 判断是否需要追溯
      if (this.isBusinessRequirement && this.currentStepId === 133) {
        return true;
      }
      return false;
    },
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    },
    // 当流转的下一步是Demo环境部署，且存在镜像比当前镜像版本低的时候，提交按钮置灰
    nextSubmitRequire() {
      let state = false;
      this.nextOptions.forEach(el => {
        if (this.processingServices.length > 0 && el.id === this.nextForm.to_step && this.templateId !== 17 && this.templateId !== 2 && el.step_type === 7) {
          state = true;
        }
      });
      return state;
    },
    nextMoveStatus() {
      return this.nextOptions.length > 0 && [0, 1].includes(this.workflowStatus);
    },
    backMoveStatus() {
      return this.backOptions && this.backOptions.length > 0 && [0, 1].includes(this.workflowStatus);
    },
    reviewUser() {
      const currentReview = this.currentStep.reviews.filter(item => item.result === 'processing');
      const reviewGroup = {};
      currentReview.forEach(item => {
        if (!reviewGroup[item.description]) {
          reviewGroup[item.description] = [];
        }
        reviewGroup[item.description].push(item.reviewer.nickname);
      });
      let item = '';
      for (const key in reviewGroup) {
        if (key === '配置确认') {
          item += '配置确认中, 如有疑问可联系运维同学: 李济恺、殷毅、江韬、邹凯; ';
        } else {
          item += `${key}: ${reviewGroup[key].join(';')}; `;
        }
      }
      return item;
    },
    mustBindTestPlans() {
      // 是否需要关联测试计划
      return [38, 40, 41, 42, 94, 96, 102, 111, 125, 146].includes(this.currentStepId);
    }
  },
  watch: {
    currentStep() {
      if (this.currentStep.back_options.length === 0 && this.currentStep.next_options.length === 0) {
        this.defaultActiveKey = 'comment';
        this.onChange('comment');
      } else {
        this.defaultActiveKey = 'next';
        this.onChange('next');
      }
      this.operationUsers = this.currentStep.operation_users;
      this.operationPermission = this.currentStep.operation_permission;
      this.nextOptions = this.currentStep.next_options;
      this.backOptions = this.currentStep.back_options;
      this.nextForm.to_step = this.nextOptions.length > 0 ? this.nextOptions[0].id : null;
      this.backForm.to_step = this.backOptions.length > 0 ? this.backOptions[0].id : null;
      const automationInfo = this.currentStep.automation;
      this.nextForm.apiTest.taskId = automationInfo.API ? automationInfo.API.task_id : null;
      this.nextForm.uiTest.taskId = automationInfo.UI ? automationInfo.UI.task_id : null;
      this.nextForm.apiTest.taskUrl = automationInfo.API ? automationInfo.API.task_url : null;
      this.nextForm.uiTest.taskUrl = automationInfo.UI ? automationInfo.UI.task_url : null;
      this.nextForm.apiTest.result = automationInfo.API ? automationInfo.API.result : null;
      this.nextForm.uiTest.result = automationInfo.UI ? automationInfo.UI.result : null;
      this.testPlans = this.currentStep.test_plans;
      this.currentStepId = this.currentStep.id;
      if ([41, 42].includes(this.currentStepId)) {
        this.currentStep.all_plans
          .filter(p => p.step === 40)
          .forEach(p => {
            this.testPlans.push(p);
          });
      }
      this.isBusinessRequirement = [129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 151, 152, 153, 154, 155, 156, 157].includes(this.currentStepId);
      this.needCompatibilityOrPerformance = [41].includes(this.currentStepId);
      this.needAutomationTest = [42, 96, 18].includes(this.currentStepId);
      this.noNeedQaTest = [102, 125].includes(this.currentStepId);
      this.devTestPlans = this.currentStep.all_plans.filter(p => p.step === 38);
      this.rules.test_plans = [{ required: this.mustBindTestPlans, message: '请关联测试计划', trigger: 'blur' }];
      [...this.nextOptions, ...this.backOptions].forEach(item => {
        this.$set(this.options, item.id, item.name);
      });
      this.getConfirmItemStatus();
      this.getConfigConfirmProgress();
    },
    testPlans() {
      this.nextForm.test_plans = this.testPlans.map(plan => {
        return { id: plan.id, plan_type: plan.type };
      });
    }
  },

  mounted() {
    // this.getAccInfo();
    this.getApplicationVersionList();
  },
  methods: {
    async brClaimOk(text, claimData) {
      // _data = {
      //   po: [],
      //   technicalManager: []
      // }
      this.nextForm.comment = text + '，并流转';
      // this.asyncNext();
      // 指派之后

      const _data = {
        record: {
          id: this.brInfo.id,
          type: 'business_req',
          to: claimData.technicalManager,
          po: claimData.po
        }
      };

      this.loading.next = true;
      businessReqModify(_data)
        .then(() => {
          console.log('businessReqModify');
          this.asyncNextForceAddPO();
        })
        .catch(() => {
          this.loading.next = false;
        });
    },
    async asyncNextForceAddPO() {
      this.loading.next = true;
      this.nextForm.release_ids = this.nextForm.release_ids === null ? [] : [this.nextForm.release_ids];
      await workflowForceAddPO({ project_id: this.projectId, is_auto_pass: this.isAutoPass, noNeedQa: this.noNeedQa, workflow_id: this.workflowId, ...this.nextForm })
        .then(res => {
          this.nextForm.comment = '';
          this.nextForm.release_ids = null;
          this.nextForm.test_plans = [];
          this.loading.next = false;
          this.$message.success(res.message);
          this.$emit('onReload');
        })
        .catch(() => {
          this.loading.next = false;
        });
    },
    brClaim(person) {
      this.$refs.brClaimModalRef.onOpen(person, this.brInfo);
    },
    async getAccInfo() {
      const res = await Accurate.getTwoDiff({
        workflow_id: this.workflowId
      });
      this.onlineDiff = { ...res.online };
      this.testDiff = { ...res.test };
    },
    onChangeIsValueRetrospect(checked) {
      if (checked) {
        if (!this.nextForm.retrospectType) {
          this.$set(this.nextForm, 'retrospectType', [1]);
        }
      }
    },
    getApplicationVersionList() {
      applicationVersionList({ app_key: '61367b74', category: 'debug', page_number: 1, page_size: 20 })
        .then(res => {
          this.packageList = res.data.items;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAccGenerateCases() {
      getAccCases({ workflow_id: this.workflowId, project_id: this.projectId, step: this.currentStepId })
        .then(res => {
          this.testPlans = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * 全选回调事件
     * @param {*} e
     */
    onConfirmAllItemChange(e) {
      const checkedItems = this.confirmItems.map(item => item.index);
      updateWorkflowConfirmItemStatus({ workflow_id: this.workflowId, index: checkedItems, status: e.target.checked });
      this.checkedConfirms = e.target.checked === true ? checkedItems : [];
      this.nextForm.confirm_items = this.checkedConfirms.length === this.confirmItems.length ? true : null;
    },

    /**
     * 选中/取消事件回调
     * @param {*} e
     * @param {*} index
     */
    onConfirmItemChange(e, index) {
      updateWorkflowConfirmItemStatus({ workflow_id: this.workflowId, index: [index], status: e.target.checked || false });
      this.nextForm.confirm_items = this.checkedConfirms.length === this.confirmItems.length ? true : null;
    },

    /**
     * 获取选中/取消状态
     */
    getConfirmItemStatus() {
      getWorkflowConfirmItems({ workflow_id: this.workflowId }).then(res => {
        const items = res.data.items;
        this.checkedConfirms = this.confirmItems.filter(e => items[e.index] === true).map(e => e.index);
        this.nextForm.confirm_items = this.checkedConfirms.length === this.confirmItems.length ? true : null;
      });
    },
    getOnlineAccurateInfo() {
      this.onlineAccVisible = true;
    },
    getTestAccurateInfo() {
      this.testAccVisible = true;
    },
    handleOk() {
      this.onlineAccVisible = false;
      this.testAccVisible = false;
    },
    viewAutomation(url) {
      window.open(url);
    },
    automationStart(type) {
      let taskId = null;
      let env = null;
      let packge = null;
      if (type === 'API') {
        taskId = this.nextForm.apiTest.taskId;
        env = this.nextForm.apiTest.env;
      }
      if (type === 'UI') {
        taskId = this.nextForm.uiTest.taskId;
        packge = this.nextForm.uiTest.package;
      }
      if (type === 'UI' && packge === null) {
        this.$message.warning('安装包不能为空');
        return;
      }
      if (type === 'API' && env === null) {
        this.$message.warning('执行环境不能为空');
        return;
      }
      if (taskId === null) {
        this.$message.warning('任务ID不能为空');
        return;
      }
      automationTrigger({ type: type, workflow_id: this.workflowId, task_id: taskId, env: env, package: packge }).then(() => {
        this.$message.success('触发自动化成功');
      });
    },
    rejectTestPlanChange(val) {
      this.backForm.plan_list = val;
    },
    getTestPlans() {
      workflowTestPlans({
        project_id: this.projectId,
        workflow_id: this.workflowId,
        step_id: this.currentStepId
      }).then(res => {
        this.testPlans = res.data.items;
        this.devTestPlans = this.testPlans.filter(p => p.step === 38);
      });
    },

    onChange(activeKey) {
      const release_ids = this.currentStep.release_list.length > 0 ? this.currentStep.release_list[0].release_id : null;
      if (activeKey === 'next') {
        this.nextForm.release_ids = release_ids;
      } else if (activeKey === 'back') {
        this.backForm.release_ids = release_ids;
      }
    },
    onCreate() {
      this.$router.push({
        name: 'page:project:workflow:release:create',
        query: { workflowId: this.$route.query.workflowId }
      });
    },
    onAddTestPlan() {
      this.testPlanVisible = true;
    },
    deletePlan(record) {
      // this.testPlans.splice(index, 1);
      unBindWorkflowTestPlan({
        project_id: this.projectId,
        workflow_id: this.workflowId,
        plan_id: record.id
      }).then(() => {
        this.$message.success('移除测试计划成功');
        this.getTestPlans();
      });
    },
    testPlanChange(rows) {
      const testPlanIds = this.testPlans.map(plan => plan.id);
      rows.forEach(row => {
        if (!testPlanIds.includes(row.id)) {
          this.testPlans.push(row);
        }
      });
      this.testPlanVisible = false;
    },
    closeTestPlanModal() {
      this.testPlanVisible = false;
      this.getTestPlans();
    },
    onDetail(record) {
      this.$router.push({
        name: 'page:project:workflow:release:detail',
        query: { releaseId: record.release_id }
      });
    },
    // 获取标签列表
    getTagList(code) {
      this.tagData = [];
      this.backForm.tags = [];
      tagList({ group_code: code }).then(res => {
        this.tagData = res.data.items;
      });
    },
    async asyncNext() {
      this.loading.next = true;
      this.nextForm.release_ids = this.nextForm.release_ids === null ? [] : [this.nextForm.release_ids];
      await workflowMove({ project_id: this.projectId, is_auto_pass: this.isAutoPass, noNeedQa: this.noNeedQa, workflow_id: this.workflowId, ...this.nextForm })
        .then(res => {
          if (res.message !== '流转成功') {
            this.submitGoToBR(res.message);
            this.$emit('onReload');
          } else {
            this.nextForm.comment = '';
            this.nextForm.release_ids = null;
            this.nextForm.test_plans = [];
            this.loading.next = false;
            this.$message.success(res.message);
            this.$emit('onReload');
          }
        })
        .catch(() => {
          this.loading.next = false;
        });
    },
    submitNext() {
      this.$refs.nextForm.validate(valid => {
        if (valid) {
          this.asyncNext();
        }
      });
    },

    /**
     * 退回操作，使用同步调用的方法处理
     */
    async handleBack() {
      this.loading.back = true;
      this.backForm.release_ids = this.backForm.release_ids === null ? [] : [this.backForm.release_ids];
      try {
        const { code, _, message } = await workflowMove({ project_id: this.projectId, env: 'qa', workflow_id: this.workflowId, ...this.backForm });
        if (code === 2000) {
          this.backForm = {
            release_ids: null,
            operation_type: 'back',
            result: null,
            tags: [],
            to_step: null,
            comment: '',
            bug_list: [],
            plan_list: []
          };
          this.loading.back = false;
          this.$message.success(message);
          this.$emit('onReload');
        }
      } catch {
        this.loading.back = false;
      }
    },
    submitGoToBR(brList) {
      const self = this;
      const brArray = brList.map(num => `【BR-${num}】`);
      this.$confirm({
        title: '业务需求验收提醒',
        content: '该需求为您负责的：' + brArray + '的最后一个需求 \n可前往业务需求进行需求验收',
        okText: '立即前往',
        cancelText: '我知道了',
        onOk() {
          return self.$router.push({
            name: 'page:business:requirement:detail',
            params: { id: brList[0] }
          }).href;
        }
      });
    },
    submitBack() {
      this.$refs.backForm.validate(valid => {
        if (valid) {
          const self = this;
          this.$confirm({
            title: '确认',
            content: `流程不通过后，将流转至「${self.options[self.backForm.to_step]}」，请确认`,
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              self.$nextTick(() => {
                self.loading.back = true;
                if (self.isBusinessRequirement) {
                  self.backForm.result = 5;
                  self.handleBack();
                } else {
                  self.$refs.rollbackModalRef.onOpen(self.workflowId, self.currentStepId);
                }
              });
            }
          });
        }
      });
    },

    submitComment() {
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          this.loading.comment = true;
          workflowComment({ project_id: this.projectId, workflow_id: this.workflowId, ...this.commentForm })
            .then(() => {
              this.commentForm.comment = '';
              this.loading.comment = false;
              this.$message.success('评论成功');
              this.$emit('onReload');
            })
            .catch(() => {
              this.loading.comment = false;
            });
        }
      });
    },
    onAddIssue() {
      this.$nextTick(() => {
        const { task_list, story_list } = this.$parent.workflowMoreInfoData;
        let taskValue = {};
        let requirementValue = {};
        if (Array.isArray(task_list) && task_list.length > 0) {
          taskValue = { key: task_list[0].id, label: task_list[0].name };
        }
        if (Array.isArray(story_list) && story_list.length > 0) {
          const tmpStory = story_list.find(story => story.parent_id === 0) || story_list[0];
          requirementValue = { key: tmpStory.id, label: tmpStory.title };
        }
        this.$refs.editModalRef.onOpen({ taskValue: taskValue, requirementValue: requirementValue });
      });
    },
    callback(issue, type) {
      this.backForm.bug_list.push(issue.id);
      this.bugList[issue.id] = issue;
    },
    async retrospectAndNext() {
      // 进行追溯并下一步
      this.$refs.nextForm.validate(async valid => {
        if (valid) {
          let retrospectType = this.nextForm.retrospectType || [];
          if (retrospectType.includes(2) && !retrospectType.includes(1)) {
            retrospectType = [1];
          }
          this.loading.next = true;
          try {
            await updateBusinessRequirementSimpleField({
              id: this.brInfo.id,
              fields: { retrospectType: JSON.stringify(retrospectType) }
            });
          } catch (e) {
            this.loading.next = false;
          }
          this.asyncNext();
        }
      });
    },
    async onSubmit(operationType) {
      if (operationType === 'next') {
        // 如果当前节点是MRD的待产品方案，并且需求涉及状态为设计中、待设计则弹窗
        // 弹窗取消则直接流转，否则先更新为设计完成状态，再流转
        const self = this;
        if (this.needRetrospect && this.nextForm.isValueRetrospect) {
          // 如果需要价值追溯
          this.retrospectAndNext();
        } else if (this.isBusinessRequirement && this.currentStepId === 135 && !this.brInfo.planOnlineTime) {
          // 没有维护预期上线时间
          this.$refs.nextForm.validate(valid => {
            if (valid) {
              this.$confirm({
                title: '温馨提示',
                content: '识别到该需求的「预计交付时间」未填写，建议完善后再提交需求流转~',
                okText: '跳过并提交',
                onOk: async () => {
                  await self.asyncNext();
                },
                onCancel() {
                  // 啥也不做
                }
              });
            }
          });
        } else if (this.isBusinessRequirement && this.currentStepId === 135 && this.brInfo.designStatus !== 3) {
          // 131 MRD待提交  135待需求方案
          const designStatusObj = this.requirementDesignStatus[this.brInfo.designStatus];
          this.$refs.nextForm.validate(valid => {
            if (valid) {
              this.$confirm({
                title: '温馨提示',
                content: '当前需求的需求设计状态为「' + (designStatusObj ? designStatusObj.label : '未设置') + '」，是否快速帮您更新为「已完成」',
                okText: '更新并提交',
                onOk: async () => {
                  const res = await updateBusinessRequirementSimpleField({
                    id: self.brInfo.id,
                    fields: { designStatus: 3 }
                  });

                  self.$message.success('状态更新成功');
                  await self.asyncNext();
                },
                onCancel() {
                  // 啥也不做
                }
              });
            }
          });
        } else if (this.isBusinessRequirement && this.currentStepId === 138 && this.nextForm && this.nextForm.collaborator && this.nextForm.collaborator.length > 0) {
          // 如果是待验收-》待验证，并且选择了协同验收人，则需要更新协同验收人
          this.$refs.nextForm.validate(valid => {
            if (valid) {
              this.loading.next = true;

              businessReqModify({
                record: {
                  id: self.brInfo.id,
                  type: 'business_req',
                  collaborator: this.nextForm.collaborator
                }
              })
                .then(() => {
                  self.submitNext();
                })
                .catch(() => {
                  this.loading.next = false;
                });
            }
          });
        } else {
          this.submitNext();
        }
      } else if (operationType === 'back') {
        this.submitBack();
      } else if (operationType === 'comment') {
        this.submitComment();
      } else if (operationType === 'autoNext') {
        this.isAutoPass = true;
        this.submitNext();
      } else if (operationType === 'noNeedQa') {
        this.noNeedQa = true;
        this.submitNext();
      } else if (operationType === 'normalNext') {
        this.noNeedQa = false;
        this.submitNext();
      }
    },
    getCountdown(targetDateStr) {
      const targetDate = moment(targetDateStr);
      const now = moment();
      const duration = moment.duration(targetDate.diff(now));

      let countdownStr = '';
      const days = duration.days();
      let hours = duration.hours();
      if (days > 0) {
        hours = hours + 24 * days;
      }
      if (hours > 0) {
        countdownStr += hours + '小时';
      }
      const minutes = duration.minutes();
      if (minutes > 0) {
        countdownStr += minutes + '分钟';
      } else {
        const seconds = duration.seconds();
        if (seconds > 0) {
          countdownStr += seconds + '秒';
        }
      }
      return countdownStr.trim();
    },

    getConfigConfirmProgress() {
      const processingReviews = this.currentStep.reviews.filter(item => item.result === 'processing' && item.description === '配置确认');
      if (processingReviews.length > 0) {
        queryConfigConfirmProgress({ workflow_id: this.workflowId })
          .then(res => {
            this.configConfirmProgress = res.data.progress;
          })
          .catch(() => {
            this.configConfirmProgress = null;
          });
      } else {
        this.configConfirmProgress = null;
      }
    }
  }
};
</script>
<style lang="less">
.small-form-model {
  .ant-form-item {
    margin-bottom: 8px;
  }
}
.search-button {
  width: 100%;
}
.testplan-form-item {
  /deep/ .ant-form-item-control {
    line-height: unset;
  }

  .steps_table {
    padding-top: 3px;
    //margin-bottom: 1px;
    width: 960px;
    //box-sizing:border-box;
    display: inline-block;

    /deep/.ant-table-tbody > tr > td {
      padding: 2px;
      border-bottom: none;
    }
  }

  .plan_table {
    padding-top: 3px;
    //margin-bottom: 1px;
    width: 960px;
    //box-sizing:border-box;
    display: inline-block;
  }
}
</style>

<style lang="less" scoped>
.ant-card {
  margin: 16px 0;
}

/deep/.ant-card-body {
  padding: 16px;
}

/deep/.ant-tabs-nav .ant-tabs-tab {
  margin: -16px 32px 0 0;
}

.release-radio {
  display: block;
  height: 30px;
  line-height: 30px;
}

.workflow-alert-info {
  margin-bottom: 8px;
}

.submit-button {
  min-width: 100px;
}
</style>
